import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ba1eded"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "operation-cover" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"show-menu-btn\" data-v-0ba1eded><i class=\"colour colour-mulu\" data-v-0ba1eded></i></div><div class=\"top\" data-v-0ba1eded>呼出/隐藏顶部菜单</div><div class=\"middle\" data-v-0ba1eded><div class=\"left\" data-v-0ba1eded>上一页</div><div class=\"right\" data-v-0ba1eded>下一页</div></div><div class=\"bottom\" data-v-0ba1eded>呼出/隐藏分页器</div>", 4)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode("目录按钮"),
    _hoisted_2
  ]))
}